import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdTranslate } from 'react-icons/md';
import { languageList } from '../../utils/i18n';

export default function Index() {
    const { i18n } = useTranslation();
    return (
        <div
            className={
                'fixed top-32 left-0 z-20 flex -translate-x-[calc(100%-54px)] gap-4 rounded-r bg-SM-yellow p-3 transition-all duration-500 hover:-translate-x-0'
            }>
            {languageList.map((language) => {
                return (
                    <button
                        onClick={() => i18n.changeLanguage(language)}
                        key={`language-${language}`}
                        className={`text-2xl font-medium uppercase text-white transition-all hover:brightness-50 ${
                            i18n.language === language ? 'brightness-50' : ''
                        }`}>
                        {language}
                    </button>
                );
            })}
            <MdTranslate className={'text-3xl'} />
        </div>
    );
}
